(() => {
  if (customElements.get('sunpura-proof-video')) return;
  let activeMedia;
  customElements.define('sunpura-proof-video', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const poster = event.target.closest('.sp-proof-video__poster');
        if (!poster || !this.contains(poster) || this.hasAttribute('loaded')) return;
        const source = this.querySelector('template')?.content.firstElementChild;
        if (!source) return;
        if (activeMedia && activeMedia !== this) activeMedia.resetMedia();
        const media = source.cloneNode(true);
        this.appendChild(media);
        this.setAttribute('loaded', '');
        activeMedia = this;
        media.focus({preventScroll: true});
        if (media instanceof HTMLVideoElement) media.play().catch(() => {});
      }, {signal: this.controller.signal});
    }
    resetMedia() {
      this.querySelectorAll(':scope > iframe, :scope > video').forEach(media => {
        if (media instanceof HTMLVideoElement) media.pause();
        media.remove();
      });
      this.removeAttribute('loaded');
      if (activeMedia === this) activeMedia = undefined;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resetMedia();
    }
  });
})();
